// extracted by mini-css-extract-plugin
export default {"fr-view":"ChapterMove_fr-view__BsLqO","error":"ChapterMove_error__ViXxM","field":"ChapterMove_field__29zuX","action":"ChapterMove_action__P5I-t"};